import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(()=>({
        root: {
            cursor: 'pointer'
        }
    }));
export { useStyles };
